import React from 'react';
import Market from '../Market';

/** Admin Market — the same page as the users' Market page (one design, one set of
 *  tabs, one name across user/semi-admin/admin menus). */
export default function AdminMarket() {
  return <Market title="Market" />;
}
